exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollable-body[data-v-3ebe163f] {\n  max-height: 400px;\n  overflow: auto;\n}\n@media screen and (max-width: 600px) {\n.modal-large[data-v-3ebe163f] {\n    height: 100vh !important;\n    background-color: red !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ebe163f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SaveFiltersModal.vue
// module id = U1XB
// module chunks = 0